'use client';
import { useEffect } from 'react';

export default function ScrollToHash() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    let attempts = 0;

    const scrollToElement = () => {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else if (attempts < 10) {
        attempts++;
        setTimeout(scrollToElement, 500); 
      }
    };

    scrollToElement();
  }, []);

  return null;
}
